import { render, staticRenderFns } from "./ModalPackageFeatures.vue?vue&type=template&id=5b3893aa&"
import script from "./ModalPackageFeatures.vue?vue&type=script&lang=js&"
export * from "./ModalPackageFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports